import React, { useEffect, useState } from "react";
import { orendaUserManager, clearLogoutStage } from "./orendaUserManager";
import { clearOrendaAuth } from "./orendaAuthStorage";

// Cognito redirects here after a hosted-UI logout.
// We finish any pending popup callback, clear all local session, then
// briefly show a friendly "Signed out" message before forwarding the user
// back to Card-Console's default sign-in screen (/login). Sign-out is a
// deliberate end-of-session action — do NOT bounce the user straight into
// another signinRedirect. If they want back in, they click "Sign in" and
// start the flow fresh.

const REDIRECT_TO = "/login";
const HOLD_MS = 1200;

const OrendaLogout = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const isPopup = window.opener && window.opener !== window;

    const finish = async () => {
      try {
        if (isPopup) {
          await orendaUserManager.signoutPopupCallback();
        } else {
          // Belt & braces — clear any lingering user + tokens in this window.
          try { await orendaUserManager.removeUser(); } catch { /* ignore */ }
          try { clearOrendaAuth(); } catch { /* ignore */ }
          // Logout chain is done — stop any future mount of our app from
          // resuming it. See continueLogoutChain().
          try { clearLogoutStage(); } catch { /* ignore */ }
          // Also wipe the legacy user + oidc-client leftover state so the
          // Redux store rehydrates with currentUser=null on next mount.
          try {
            window.sessionStorage.removeItem("user");
            window.sessionStorage.removeItem("orendaAuth");
            window.sessionStorage.removeItem("orendaCard");
            for (const key of Object.keys(window.sessionStorage)) {
              if (key.startsWith("oidc.")) window.sessionStorage.removeItem(key);
            }
          } catch { /* ignore */ }
        }
      } catch (e) {
        setError(e.message || String(e));
      }
    };

    finish();

    // Only auto-redirect if we're a full-page navigation (not a popup handshake).
    if (isPopup) return;
    const t = window.setTimeout(() => {
      window.location.replace(REDIRECT_TO);
    }, HOLD_MS);
    return () => window.clearTimeout(t);
  }, []);

  return (
    <section className="bo-form-screens">
      <div className="container-fluid">
        <div className="row minvh-100" style={{ alignItems: "center", justifyContent: "center" }}>
          <div className="col-md-8 col-lg-6" style={{ textAlign: "center", padding: "40px 24px" }}>
            <h2 className="orenda-heading" style={{ marginBottom: 12 }}>
              You've been signed out
            </h2>
            <p className="orenda-subheading" style={{ marginBottom: 20 }}>
              {error
                ? "There was a small hiccup finishing sign-out, but your session is cleared."
                : "Redirecting you to the sign-in page…"}
            </p>
            <a href={REDIRECT_TO} className="orenda-btn-primary">
              Sign in again
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrendaLogout;
